import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";

const VendorsLotPaymentsTitleColumns = () => (
    <>
        <GridTable.Data columnStart={1} rowStart={1} rowWidth={1}>
            <I18n component="span" id="transfer.coelsa.id" />
        </GridTable.Data>
        <GridTable.Data columnStart={2} rowStart={1} rowWidth={1}>
            <I18n component="span" id="payThirdParties.desteny.cbu.label" />
        </GridTable.Data>
        <GridTable.Data columnStart={3} rowStart={1} rowWidth={1}>
            <I18n component="span" id="payThirdParties.account.type.label" />
        </GridTable.Data>
        <GridTable.Data columnStart={4} rowStart={1} rowWidth={1}>
            <I18n component="span" id="payThirdParties.document.type.label" />
        </GridTable.Data>
        <GridTable.Data columnStart={5} rowStart={1} rowWidth={1}>
            <I18n component="span" id="transfer.amountField.label" />
        </GridTable.Data>
        <GridTable.Data columnStart={6} rowStart={1} rowWidth={1}>
            <I18n component="span" id="accounts.movement.detail.voucher" />
        </GridTable.Data>
        <GridTable.Data columnStart={7} rowStart={1} rowWidth={1}>
            <I18n component="span" id="payThirdParties.motive.label" />
        </GridTable.Data>
        <GridTable.Data columnStart={8} rowStart={1} rowWidth={1} className="payments-span">
            <I18n component="span" id="tableHeader.state" />
        </GridTable.Data>
    </>
);
export default VendorsLotPaymentsTitleColumns;
